import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot
} from '@angular/router';
import { AuthenticationService } from './Authentication.service';

@Injectable()
export class RoleGuardService implements CanActivate {
  isResponsableClient: boolean;

  constructor(public auth: AuthenticationService, public router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    // this will be passed from the route config
    // on the data property
    const roles = route.data.roles;
    return this.auth.IsResponsableClient().toPromise().then((response) => {
      
      this.isResponsableClient = response;
      let hasPermission = this.auth.IsAuthenticated() && this.isResponsableClient;      
      if (hasPermission) 
      {        
        return true;    
      }          
      this.router.navigate(['login']);
      return false;
     }, (error) => {      
      this.router.navigate(['login']);
      return false;       
     });
  }
}